import * as React from 'react';
import { FormControl, InputLabel, Input, Button, Grid } from '@material-ui/core';
import { Guid } from 'guid-typescript';

const items: any =
{
    title: {
        en: ''
    },
    choices: [{
        value: '',
        text: {
            en: ''
        }
    }]
};

export default class QuestionOptionsComponent extends React.Component<any, any> {
    constructor(props: any) {
        super(props);
        this.state = {
            options: [],
            showExtraTextbox: false,
            errors: {},
            autoFocusText: true,
            autoFocusValue: false
        };
        this.handleText = this.handleText.bind(this);
        this.handleValue = this.handleValue.bind(this);
        this.saveQuestionOptions = this.saveQuestionOptions.bind(this)
    }

    componentDidMount() {
        if (this.props.dataSource && this.props.dataSource.length) {
            this.renderOptionsIfItemsExists();
        }
        else {
            const options = this.state.options;
            for (let i = 0; i < this.props.selectedClassType; i++) {
                options.push(items)
            }
            this.setState({ options })
        }
        this.setState({ errors: this.props.errors });
    }

    UNSAFE_componentWillReceiveProps(nextProps: any) {
        const optionArray = [];
        if (nextProps.selectedClassType !== this.props.selectedClassType) {
            if (nextProps.dataSource && nextProps.dataSource.length) {
                let newOptionArray = []
                for (let i = 1; i < nextProps.selectedClassType; i++) {
                    optionArray.push(items);
                }
                newOptionArray = [...nextProps.dataSource, ...optionArray]
                this.setState({ options: newOptionArray })
            } else {
                this.setState({ options: [items] });
            }
        }
        this.setState({ errors: nextProps.errors });
    }

    renderOptionsIfItemsExists() {
        if (this.props.dataSource.length === this.props.question.class_type) {
            this.setState({ options: this.props.dataSource });
        }
        else if (this.props.question.class_type > this.props.dataSource.length) {
            let options = this.props.dataSource;
            for (let index = 1; index <= this.props.question.class_type - this.props.dataSource.length; index++) {
                options = [...options, items];
            }
            this.setState({ options });
        }
        else {
            const options = this.props.dataSource;
            options.length = this.props.question.class_type;
            this.setState({ options });
        }
    }

    handleText = (optionIndex: any, choicesIndex: any, e: any) => {
        const options = Object.assign([], this.state.options);
        const optionsString = JSON.stringify(options);
        const optionsObj = JSON.parse(optionsString);
        const name = e.target.name;

        const choice = optionsObj[optionIndex].choices[choicesIndex];
        const yAxis = window.scrollY;
        choice.text.en = e.target.value;
        this.setState({ options: optionsObj }, () => setTimeout(() => {
            window.scrollTo(0, yAxis);
            // this.setState({ [name]: true });
        }, 0));
        setTimeout(() => {
            this.setState({ [name]: true }, () => console.log(this.state))
        }, 100);

    }

    handleValue = (optionIndex: any, choicesIndex: any, e: any) => {
        const options = Object.assign([], this.state.options);
        const optionsString = JSON.stringify(options);
        const optionsObj = JSON.parse(optionsString);
        // const name = 'value_' + choicesIndex + '_' + optionIndex + '_' + this.props.questionIndex + '_' + this.props.clusterIndex + '_' + this.props.pageNumber;
        const name = e.target.name;

        const choice = optionsObj[optionIndex].choices[choicesIndex];
        choice.value = e.target.value;
        const yAxis = window.scrollY;
        this.setState({ options: optionsObj }, () => setTimeout(() => {
            window.scrollTo(0, yAxis);
        }, 0));
        setTimeout(() => {
            this.setState({ [name]: true });
        }, 100);
    }

    modifyRows(val: any, stepIndex: any) {
        const options: any = [...this.state.options];
        const optionsStr = JSON.stringify(options);
        const optionsCopy = JSON.parse(optionsStr);
        if (val === 'add') {
            const classType = this.props.question.class_type ? this.props.question.class_type : 1;
            // if (/* this.props.selectedClassType */ classType === 1) {
            if (classType === 1) {
                optionsCopy[0].choices.push(items.choices[0])
            } else {
                optionsCopy[stepIndex].choices.push(items.choices[0]);
            }
        } else {
            optionsCopy[stepIndex].choices.pop()
        }
        this.setState({ options: optionsCopy });
    }

    saveQuestionOptions() {
        this.validateAndSaveOptions(this.updateMainState);
        this.setState({ showExtraTextbox: true });
    }

    updateMainState = () => {
        this.props.updateModule(
            {
                data: {
                    pageNumber: this.props.pageNumber,
                    clusterIndex: this.props.clusterIndex,
                    questionIndex: this.props.questionIndex,
                    value: this.state.options
                },
                field: 'addQuestionOptions'
            }
        )
    }

    validateAndSaveOptions = (callback: () => void): void => {
        const errors = {};
        if (this.state.options.length >= 0) {
            const options = this.state.options;
            for (const option of options) {
                for (const choice of option.choices) {
                    if (choice.text.en && choice.value) {
                        if (choice.text.en) {
                            delete this.state.errors[`questionOption_${this.props.pageNumber}${this.props.clusterIndex}${this.props.questionIndex}`];
                            delete this.state.errors[`questionOptionText_${this.props.pageNumber}${this.props.clusterIndex}${this.props.questionIndex}`];
                        }
                        if (choice.value) {
                            delete this.state.errors[`questionOption_${this.props.pageNumber}${this.props.clusterIndex}${this.props.questionIndex}`];
                            delete this.state.errors[`questionOptionValue_${this.props.pageNumber}${this.props.clusterIndex}${this.props.questionIndex}`];
                        }
                    }
                    else {
                        if (!choice.text.en) {
                            errors[`questionOptionText_${this.props.pageNumber}${this.props.clusterIndex}${this.props.questionIndex}`] = 'Text is mandatory.';
                        }
                        if (!choice.value) {
                            errors[`questionOptionValue_${this.props.pageNumber}${this.props.clusterIndex}${this.props.questionIndex}`] = 'Value is mandatory.';
                        }
                    }
                }
            }
        }
        if (!errors[`questionOptionText_${this.props.pageNumber}${this.props.clusterIndex}${this.props.questionIndex}`] && !errors[`questionOptionValue_${this.props.pageNumber}${this.props.clusterIndex}${this.props.questionIndex}`]) {
            callback();
        }
        else {
            this.setState({ errors });
        }
    }

    render() {
        return (
            <div>
                <b><u>Options Configuration</u></b>
                <span> (Please click on Apply button when you are done with filling up the options.) </span>
                {<Grid id="option" container={true} spacing={8} className="margin-top-10"
                    key={Guid.create().toString()}
                >
                    <Grid item={true} xs={6} key={Guid.create().toString()}>
                        {
                            this.state.options.map((optItem: any, ind: any) => {
                                return <div key={Guid.create().toString()} >
                                    <div className="optionsBox">
                                        <b>Step {ind + 1}</b>
                                        {optItem.choices.map((item: any, index: any) => {
                                            return <div key={Guid.create().toString()}>
                                                <Grid
                                                    key={Guid.create().toString()}
                                                    container={true}
                                                    spacing={16}>

                                                    <Grid xs={6} item={true}
                                                        key={Guid.create().toString()}
                                                    >
                                                        <FormControl margin="normal" required={true} fullWidth={false}>
                                                            <InputLabel htmlFor="handleQuestionNo">Text</InputLabel>
                                                            <Input
                                                                name={'text_' + index + '_' + ind + '_' + this.props.questionIndex + '_' + this.props.clusterIndex + '_' + this.props.pageNumber}
                                                                onChange={this.handleText.bind(this, ind, index)}
                                                                value={item.text.en}
                                                                autoFocus={this.state['text_' + index + '_' + ind + '_' + this.props.questionIndex + '_' + this.props.clusterIndex + '_' + this.props.pageNumber]}
                                                            />
                                                        </FormControl>
                                                    </Grid>
                                                    <Grid xs={6} item={true} key={Guid.create().toString()}>
                                                        <FormControl margin="normal" required={true} fullWidth={false}>
                                                            <InputLabel htmlFor="handleQuestionNo">Value</InputLabel>
                                                            <Input
                                                                name={'value_' + index + '_' + ind + '_' + this.props.questionIndex + '_' + this.props.clusterIndex + '_' + this.props.pageNumber}
                                                                onChange={this.handleValue.bind(this, ind, index)}
                                                                value={item.value}
                                                                autoFocus={this.state['value_' + index + '_' + ind + '_' + this.props.questionIndex + '_' + this.props.clusterIndex + '_' + this.props.pageNumber]}
                                                            />
                                                        </FormControl>
                                                    </Grid>
                                                </Grid>
                                            </div>
                                        })
                                        }
                                    </div>
                                    <div key={Guid.create().toString()} className="addOptions">
                                        <Grid container={true} spacing={8}>
                                            <Grid xs={9} item={true}>
                                                {
                                                    <>
                                                        <Button type="button" value="Add" onClick={this.modifyRows.bind(this, 'add', ind)}>+</Button>
                                                        <Button type="button" value="Sub" onClick={this.modifyRows.bind(this, 'sub', ind)}>-</Button>
                                                    </>
                                                }
                                            </Grid>
                                        </Grid>
                                    </div>
                                </div>
                            })
                        }
                    </Grid>
                    <Grid key={Guid.create().toString()} item={true} xs={6} >
                        {
                            this.state.errors && (this.state.errors[`questionOptionText_${this.props.pageNumber}${this.props.clusterIndex}${this.props.questionIndex}`] ||
                                this.state.errors[`questionOptionValue_${this.props.pageNumber}${this.props.clusterIndex}${this.props.questionIndex}`] ||
                                this.state.errors[`questionOption_${this.props.pageNumber}${this.props.clusterIndex}${this.props.questionIndex}`]) && (
                                <div className="opt-error">
                                    <div className="error">
                                        {this.state.errors[`questionOption_${this.props.pageNumber}${this.props.clusterIndex}${this.props.questionIndex}`]}
                                    </div>
                                    <div className="error" >
                                        {this.state.errors[`questionOptionText_${this.props.pageNumber}${this.props.clusterIndex}${this.props.questionIndex}`] && this.state.errors[`questionOptionText_${this.props.clusterIndex}${this.props.questionIndex}`]}
                                    </div>
                                    <div className="error" >
                                        {this.state.errors[`questionOptionValue_${this.props.pageNumber}${this.props.clusterIndex}${this.props.questionIndex}`] && this.state.errors[`questionOptionValue_${this.props.clusterIndex}${this.props.questionIndex}`]}
                                    </div>
                                </div>
                            )
                        }
                    </Grid>
                </Grid>}
                <Grid container={true} spacing={24}>
                    <Grid item={true} xs={3}>&nbsp;</Grid>
                    <Grid xs={3} item={true} >
                        <Button type="button" className="btn-blue" variant="outlined" value="Apply" onClick={this.saveQuestionOptions}>Apply</Button>
                    </Grid>
                </Grid>
            </div>

        );
    }
}



// WEBPACK FOOTER //
// ./src/components/questions/QuestionOptionsComponent.tsx